
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Website } from '@/services/Website/interfaces';

@Component
export default class WebsiteLogsResult extends Vue {
  @Prop({ type: Object, required: true })
  public website!: Website;

  @Prop({ type: String, required: true })
  public logType!: string;

  @Prop({ type: Number, required: true })
  public lines!: number;

  @Prop({ type: Array, default: null })
  public logs!: string[] | null;

  @Prop({ type: Boolean, default: false })
  public pending!: boolean;

  @Prop({ type: Boolean, default: false })
  public timedOut!: boolean;

  public get logsText(): string {
    return (this.logs || []).join('\n');
  }
}
